import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { Field } from 'redux-form'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'
import { Input } from 'components/common/FormElements/Input'
import UpdatingBlock from 'components/common/UpdatingBlock'
import { ADDING_TO_SHOPPING_QUOTE } from 'components/common/UpdatingBlock/constants'
import { formatPrice } from 'helpers/utils'
import CheckboxDescription from './components/CheckboxDescription'
import ApplySavingsButton from './components/ApplySavingsButton'
import CheckboxListField from './components/CheckboxListField'

const RadioButton = styled(Input)`
  display: block;

  & + & {
    margin-left: 0;
  }
`

const BOTPromotionLightbox = ({
  hasSelectedRebatePromotions,
  totalAfterSavingsPrice,
  availablePromotions,
  activePromotions,
  mainRebatePrice,
  description,
  productInfo,
  viewModel,
  promoId
}) =>
  <Form noValidate>
    <UpdatingBlock name={ ADDING_TO_SHOPPING_QUOTE } value={ Array(promoId).join(',') }>
      <Block>
        { availablePromotions.map((promo, index) =>
          <Field
            { ...viewModel.availablePromotions }
            topPosition
            key={ index }
            label={ <CheckboxDescription promo={ promo } /> }
            value={ promo.promotionId }
            component={ RadioButton } />)
        }
      </Block>
      {
        Boolean(activePromotions.length) &&
          <Block>
            <Plus title="Plus" />
            <Field { ...viewModel.activePromotion } component={ CheckboxListField } />
          </Block>
      }
      <SavingsBlock>
        {
          !!Number(totalAfterSavingsPrice) &&
          <Row>
            <Col important>Total After Savings*</Col>
            <Col important>{ formatPrice(totalAfterSavingsPrice) }</Col>
          </Row>
        }
        {
          !!Number(mainRebatePrice) &&
          <Row hide={ !hasSelectedRebatePromotions }>
            <Col>After Mail-In Rebate(s)</Col>
            <Col>{ formatPrice(mainRebatePrice) }</Col>
          </Row>
        }
      </SavingsBlock>
      <ApplySavingsButton
        type="button"
        productInfo={{
          ...productInfo,
          promoId
        }} />

      <TotalSavingsDescription>{ description }</TotalSavingsDescription>
    </UpdatingBlock>
  </Form>

BOTPromotionLightbox.propTypes = {
  activePromotions: PropTypes.arrayOf(PropTypes.shape()),
  availablePromotions: PropTypes.arrayOf(PropTypes.shape()),
  description: PropTypes.string,
  hasSelectedRebatePromotions: PropTypes.bool,
  mainRebatePrice: PropTypes.string,
  productInfo: PropTypes.shape(),
  promoId: PropTypes.arrayOf(PropTypes.string),
  rearSKUQuantity: PropTypes.number,
  totalAfterSavingsPrice: PropTypes.string,
  viewModel: PropTypes.shape({
    activePromotion: PropTypes.shape(),
    availablePromotions: PropTypes.shape()
  })
}

export default BOTPromotionLightbox

const Form = styled.form`
  margin: 0 auto;
`

const Block = styled.div`
  position: relative;
  ${Mixin.responsive('padding', '0 0 20px', '7px 0 25px')};
`

const SavingsBlock = styled.div`
  border-top: 1px solid ${Theme.colors.light_grey};
  ${Mixin.responsive('padding', '5px 0 30px', '7px 0 25px')};
`

const Plus = styled.div`
  position: relative;
  margin: 0 0 30px;
  border-top: 1px solid ${Theme.colors.light_grey};
  text-align: center;

  &::before {
    content: "${props => props.title}";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: block;
    padding: 0 10px;
    background-color: ${Theme.colors.white};
    ${Mixin.font.GothamBold(12)}
  }
`
const Row = styled.div`
  line-height: 30px;
  min-height: 30px;
  ${Mixin.clearFix()}

  &:first-child {
    margin-top: 10px;
  }

  ${props => props.hide && css`
    visibility: hidden;
  `}
`

const Col = styled.div`
  float: left;

  & + & {
    float: right;
    margin-left: 5px;
  }

  ${props => props.important && css`
    color: ${Theme.colors.dark_red};
    ${Mixin.font.GothamBold(18)}
  `}
  ${props => !props.important && css`
    & + & {
      font-weight: 600;
      ${Media.mobile`
        font-weight: 700;
      `}
    }
  `}
`

const TotalSavingsDescription = styled.div`
  color: ${Theme.colors.semidark_grey};
  font-style: italic;
  ${Mixin.font.GothamBook(12, 400)}
`
